import { ReactComponent as Warranty2YearsSVG } from '@/assets/warranty-2-years.svg';
import { ReactComponent as Warranty2YearsDarkSVG } from '@/assets/warranty-2-years-dark.svg';
import { ReactComponent as Warranty3YearsSVG } from '@/assets/warranty-3-years.svg';
import { ReactComponent as Warranty3YearsDarkSVG } from '@/assets/warranty-3-years-dark.svg';

import * as S from './WarrantyImage.styles';

export interface WarrantyImageProps {
  dark?: boolean;
  height?: string;
  warrantyExtensionDuration?: string;
  width?: string;
}

const warrantySVGMap: { [key: string]: React.ElementType } = {
  '2': Warranty2YearsSVG,
  '3': Warranty3YearsSVG,
  '2dark': Warranty2YearsDarkSVG,
  '3dark': Warranty3YearsDarkSVG,
};

export const WarrantyImage = ({
  dark = false,
  height,
  warrantyExtensionDuration,
  width,
}: WarrantyImageProps) => {
  const SelectedWarrantySVG =
    warrantySVGMap[`${warrantyExtensionDuration}${dark ? 'dark' : ''}` || ''];

  return SelectedWarrantySVG ? (
    <S.WarrantyImageWrapper $height={height} $width={width}>
      <SelectedWarrantySVG
        aria-hidden='true'
        data-testid={`WarrantyImage-${warrantyExtensionDuration}`}
        focusable='false'
      />
    </S.WarrantyImageWrapper>
  ) : null;
};
